<template>
  <header class="py-6">
      <div class="container flex justify-between items-center mx-auto px-8 md:px-14 lg:px-24 w-full">
          <div class="text-lg capitalize">fabricio bencomo</div>
          <div class="md:flex hidden space-x-12 items-center">
              <a href="#">Home</a>
              <a href="#about" >About</a>
              <a href="#experience" >Experience</a>
              <a href="#work" >Work</a>
              <a href="#hire"><button class="px-6 py-2 bg-theme rounded-sm font-bold text-white">Contact Me</button></a>
          </div>
      </div>
  </header>
</template>

<script>
export default {

}
</script>

<style>

</style>